interface IWxAuthEnvironment {
  isMp?: boolean;
  isQw?: boolean;
  isWx?: boolean;
}

interface IWxAuthQuery {
  appId?: string;
  code?: string;
}

export const getWxOfficialAuthQuery = (search: string, environment: IWxAuthEnvironment): IWxAuthQuery => {
  const { isMp, isQw, isWx } = environment;
  if (!isWx || isQw || isMp) return {};

  const searchParams = new URLSearchParams(search);
  const code = searchParams.get('code') || undefined;
  const appId = searchParams.get('appId') || searchParams.get('appid') || undefined;

  return { code, appId };
};
